import { showVideoAndPlay } from './showVideoAndPlay';
import { togglePlaying } from './togglePlaying';
import { hideVideo } from './hideVideo';

/**
 * Sets up event handlers for the video element to manage its display and playback.
 * Handles events like 'canplaythrough' to show the video and start playback.
 * @param {HTMLVideoElement} videoElement - The video element to set up event handlers for.
 * @param {HTMLElement} videoContainer - The container element for the video.
 */
export function setupVideoEventHandlers(videoElement, videoContainer) {
  videoElement.addEventListener('canplaythrough', () => {
    showVideoAndPlay(videoElement, videoContainer);
  });

  videoElement.addEventListener('playing', () => {
    console.log('Clearing play check buffer');
  });

  videoElement.addEventListener('click', () => {
    togglePlaying(videoElement);
  });
/*
  if (/iP(hone|od|ad)/.test(navigator.platform)) { // NOT depricated
    let lockPause = false;
    let wasFullScreen = true;
    function testLockPause() {
      const isFullscreen = document.fullscreenElement || document.webkitFullscreenElement;
      lockPause = wasFullScreen!=isFullscreen;
      wasFullScreen = isFullscreen;
      setTimeout(testLockPause, 300);
    }
    testLockPause();
    videoElement.addEventListener('pause', () => {
      if (lockPause) {
        videoElement.play();
      }
    });
  }
*/
}
